// import img from '../assets/img/spartaquant/home.png';
// import logos from '../assets/img/logo/logo-1.svg';

// require('../assets/vendors/liquid-icon/liquid-icon.min.css')
// require('../assets/vendors/font-awesome/css/font-awesome.min.css')
// require('../assets/css/theme-vendors.min.css')
// require('../assets/css/theme.min.css')
require('../assets/css/themes/spartaquant.css')
require('../assets/css/spartaquant-main.css')

require('../web/js/menu.vue.js')
require('../web/js/content-intro.vue.js')
require('../web/js/client-partner.vue.js')
require('../web/js/content-how.vue.js')
require('../web/js/content-audience.vue.js')
require('../web/js/content-functionalities.vue.js')
require('../web/js/content-video.vue.js')
require('../web/js/content-examples.vue.js')
require('../web/js/content-releases.vue.js')
require('../web/js/content-statistics.vue.js')
require('../web/js/content-testimonials.vue.js')
require('../web/js/content-pricing.vue.js')
require('../web/js/content-blog.vue.js')
require('../web/js/content-footer.vue.js')
require('../web/js/content-social.vue.js')
require('../web/js/content-spartacus-lab.vue.js')
require('../web/js/download-app.vue.js')
require('../web/js/contact-beta-tester.vue.js')
require('../web/js/contact-us.vue.js')
require('../web/js/contact-enterprise.vue.js')
require('../web/js/contact-partner.vue.js')
require('../web/js/appContainer.vue.js')
require('../web/js/app.js')